var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.423 15.66a16.8 16.8 0 0 0-3.509-2.348c-1.052-.505-1.437-.495-2.182.042-.62.448-1.02.864-1.734.708a10.342 10.342 0 0 1-3.483-2.577 10.268 10.268 0 0 1-2.577-3.483c-.151-.719.266-1.114.708-1.734.536-.745.552-1.13.042-2.182A16.467 16.467 0 0 0 4.343.576c-.765-.765-.937-.6-1.359-.448A7.734 7.734 0 0 0 1.74.789 3.754 3.754 0 0 0 .243 2.365c-.3.64-.64 1.833 1.109 4.946a27.6 27.6 0 0 0 4.851 6.474l.005.005.005.005a27.706 27.706 0 0 0 6.472 4.852c3.113 1.749 4.306 1.406 4.946 1.109a3.69 3.69 0 0 0 1.578-1.491 7.731 7.731 0 0 0 .661-1.244c.151-.424.323-.596-.447-1.361z",
    fill: "#0b72b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.98d33f30d415f1c35e0a1d40ba25ed45.svg";
export { ForwardRef as ReactComponent };